import { render, staticRenderFns } from "./PageResultInfo.vue?vue&type=template&id=5393b643&scoped=true&"
import script from "./PageResultInfo.vue?vue&type=script&lang=js&"
export * from "./PageResultInfo.vue?vue&type=script&lang=js&"
import style0 from "./PageResultInfo.vue?vue&type=style&index=0&id=5393b643&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5393b643",
  null
  
)

export default component.exports